import { modes as originalModes } from '@mapbox/mapbox-gl-draw/src/constants';
export { cursors, geojsonTypes, events, meta, activeStates } from '@mapbox/mapbox-gl-draw/src/constants';

export const modes = {
    ...originalModes,
    DRAW_CIRCLE: 'draw_circle',
    DRAW_BEZIER_CURVE: 'draw_bezier_curve'
};

export const properties = {
    CIRCLE_RADIUS: 'circleRadius',
    CIRCLE_HANDLE_BEARING: 'circleHandleBearing'
};
